<ng-container *ngIf="!loading(); else showLoading">
  <ng-container *ngIf="hasAccess === false; else showLastLogin">
    <a (click)="inviteUserToApp()">
      {{ 'ASSOCIATIONS.COMPANY.INVITE' | translate : { appName: businessAppName$ | async } }}
    </a>
  </ng-container>
  <ng-template #showLastLogin>
    <div *ngIf="lastLogin$ | async as lastLogin; else shimmer">
      <span>{{ 'ASSOCIATIONS.COMPANY.LAST_LOGIN_DATE' | translate : { lastLoginDate: lastLogin } }}</span>
    </div>
  </ng-template>
  <ng-template #shimmer>
    <div class="stencil-shimmer loading-shimmer"></div>
  </ng-template>
</ng-container>

<ng-template #showLoading>
  <mat-spinner [diameter]="20" [strokeWidth]="2" [color]="'primary'"></mat-spinner>
</ng-template>
